define 'custom/media-query', ['jquery'], ($) ->

  # use jQuery's buildin event mechanism
  events = $({})

  result =
    on: -> events.on.apply(events, arguments)
    off: -> events.off.apply(events, arguments)
    update: ->
      result.width = $(window).width()
      updateBreakpoints()
      updateRanges()

  breakpoints =
    XS: 321
    S: 575
    M: 769
    L: 991
    XL: 1201
    XXL: 1440

  betweenRanges = [
    { from: 'S', to: 'M' }
    { from: 'S', to: 'L' }
    { from: 'M', to: 'L' }
  ]

  # calculate lower and greater states
  updateBreakpoints = ->
    currentWidth = $(window).width()
    for point, width of breakpoints
      currentUpTo = currentWidth < width
      existingUpTo = result["up_to_#{point}"]

      if currentUpTo isnt existingUpTo
        result["up_to_#{point}"] = currentUpTo
        result["#{point}_and_up"] = !currentUpTo
        # dont trigger change event on first run
        events.trigger("change:#{point}") if existingUpTo?

  # calculate range states
  updateRanges = ->
    currentWidth = $(window).width()
    for range in betweenRanges
      name = "#{range.from}_to_#{range.to}"
      current = breakpoints[range.from] <= currentWidth and currentWidth < breakpoints[range.to]
      existing = result[name]

      if current isnt existing
        result[name] = current
        # dont trigger change event on first run
        events.trigger("change:#{name}") if existing?


  update = ->
    result.width = $(window).width()
    updateBreakpoints()
    updateRanges()

  result